import * as React from "react";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { ListItemText, Select } from "@material-ui/core";
import Checkbox from "@mui/material/Checkbox";

import { useAuth } from "../../../context/ContextApi";
import api from "../../../config/api";
import { useCallback } from "react";
// TODO: HOIST UP TO OPTIONS VALUE AND FETCH FROM API

const MenuProps = {
  variant: "menu",
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  getContentAnchorEl: null,
};

export default function MultipleServicesSelectChip({
  values,
  handleCollaboratorServicesChange,
  label,
  className = "multiple-select-chip",
}) {
  const [services, setServices] = useState([]);
  const { service, userEstablishment } = useAuth();
  const getServices = useCallback(async () => {
    const response = await api.get(`/product/?type=${service}&establishment=${userEstablishment}`);
    // console.log("getServices");
    // console.log(response.data);
    setServices(response.data);
  }, [service, userEstablishment]);

  useEffect(() => {
    getServices();
  }, [getServices]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    const newValue = value[value.length - 1];
    let newValues = value;
    if (value.find((val, i) => val._id === newValue._id && i !== value.length - 1)) {
      newValues = newValues.filter((val) => val._id !== newValue._id);
    }
    handleCollaboratorServicesChange(newValues);
  };
  const checkValue = (value) => {
    for (const obj of values) {
      for (const key in obj) {
        if (obj[key] === value) {
          return true;
        }
      }
    }
    return false;
  };
  return (
    <FormControl
      className={className}
      sx={{
        "& .MuiInputBase-input": { height: "auto" },
      }}
    >
      <InputLabel className="h-auto" id={`demo-multiple-chip-${label}`}>
        {label}
      </InputLabel>
      <Select
        labelId={`demo-multiple-chip-${label}`}
        multiple
        value={values}
        className="h-auto"
        onChange={handleChange}
        input={<OutlinedInput className="h-auto" id="select-multiple-chip" label="Chip" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value.name} label={value.name} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {services.map((value, index) => (
          <MenuItem key={value._id} value={value}>
            <Checkbox checked={checkValue(value._id)} />
            <ListItemText primary={value.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

// renderValue={(selected) => (
//   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//     {selected.map((value, index) => (
//       <Chip key={value + index} label={value} />
//     ))}
//   </Box>
// )}
// MenuProps={MenuProps}
// >
// {services.map((value) => (
//   <MenuItem className="variations-menu" key={value._id} value={value._id}>
//     <Checkbox checked={services.indexOf(value.name) > -1} />
//     <ListItemText primary={value.name} />
//   </MenuItem>
// ))}
// </Select>
